import React, {useState} from 'react'
import {message, Modal, Table} from "antd"
import Paragraph from "antd/lib/typography/Paragraph"
import {getDiamondRecord} from "../../../../../api/clubMemberList"

const MemberDiamondRecord = ({memberId}) => {
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [diamondRecord, setDiamondRecord] = useState([])
    const [page, setPage] = useState({
        page: 1,
        total: 0,
    })

    const columns = [
        {
            title: '会员',
            dataIndex: 'account',
            key: 'account',
        },
        {
            title: '期初钻石',
            dataIndex: 'init',
            key: 'init',
        },
        {
            title: '增加钻石',
            dataIndex: 'income',
            key: 'income',
        },
        {
            title: '支出钻石',
            dataIndex: 'outcome',
            key: 'outcome',
        },
        {
            title: '结余钻石',
            dataIndex: 'balance',
            key: 'balance',
        },
        {
            title: '时间',
            dataIndex: 'ctime',
            key: 'ctime',
        },
        {
            title: '备注',
            dataIndex: 'note',
            key: 'note',
        },
        {
            title: '流水号',
            dataIndex: 'serial_number',
            key: 'serial_number',
            render: (text) => (<Paragraph copyable>{text}</Paragraph>)
        },
    ]

    const fetchMemberDiamondRecord = async () => {
        setIsLoading(true)
        await getDiamondRecord(memberId, page.page).then(res => {
            setDiamondRecord(res.list)
            setPage(prevState => {
                return {
                    ...prevState,
                    total: res.total,
                }
            })
        }).catch(err => {
            console.log(err)
            message.error(`获取钻石记录失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleClick = async () => {
        setIsShow(true)
        await fetchMemberDiamondRecord()
    }


    return (
        <div>
            <div onClick={handleClick}>钻石足迹</div>
            <Modal
                open={isShow}
                width={1000}
                onCancel={() => setIsShow(false)}
                footer={null}
                title={"钻石足迹"}
            >
                <Table
                    columns={columns}
                    dataSource={diamondRecord}
                    pagination={{
                        total: page.total,
                        onChange: (page) => setPage(prevState => {
                            return {
                                ...prevState,
                                page: page
                            }
                        })
                    }}
                    loading={isLoading}
                />
            </Modal>
        </div>
    )
}

export default MemberDiamondRecord


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindDiamond.js